import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto, AgentOtpChannelEnum, SentOtpDto } from '../../../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-login-forgot-password-otp',
	templateUrl: './login-forgot-password-otp.component.html',
	styleUrl: './login-forgot-password-otp.component.scss',
	standalone: false
})
export class LoginForgotPasswordOtpComponent implements OnInit {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	form!: FormGroup;
	submitting: boolean = false;
	showPassword = false;
	message?: string;
	sentOtp?: SentOtpDto;

	constructor(private authService: AuthService, private fb: FormBuilder) {

	}

	ngOnInit(): void {
		this.form = this.fb.group({
			otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
		});
		this.authService.doSendForgotPasswordOtp(this.agent.username, true).subscribe(result => {
			this.sentOtp = result;
		});
	}

	onSubmit() {
		const otp = this.form.get('otp')!.value;

		this.submitting = true;
		this.authService.doCheckUsernameAndOtpForForgotPassword(this.agent.username, otp)
			.pipe(
				finalize(() => this.submitting = false)
			)
			.subscribe(result => {
				if (result.success == false) {
					this.message = result.message;
					return;
				}
				result.agent!.otp = otp;
				switch (result.agent!.status) {
					case 'PendingRegistration': return this.doUpdateState.emit({ mode: 'CaptureRegistrationOtp', agent: result.agent });
					case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: result.agent });
					case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: result.agent });
					case 'Approved': return this.doUpdateState.emit({ mode: 'ForgotPasswordSetNew', agent: result.agent });
					case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent });
					case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: result.agent });
				}
			});
	}

	reset() {
		this.doUpdateState.emit({ mode: 'CaptureUsername', agent: this.agent });
	}
	isInvalid(field: string): boolean {
		return !!(this.form.get(field)?.invalid && this.form.get(field)?.touched);
	}
	showForgotPassword() {
		this.doUpdateState.emit({ mode: 'ForgotPasswordOtp', agent: this.agent });
	}
	reSend(channel: AgentOtpChannelEnum) {
		this.authService.doSendForgotPasswordOtp(this.agent.username, false, channel).subscribe(result => {
			this.sentOtp = result;
		});
	}

}
